import React, { ReactElement } from "react"
import { useSelector } from "react-redux";
import { UserEarningsReportForm } from "./UserEarningsReportForm";
import { getAdboxReport } from "../../selectors/monetizationSelector";
// import { aggregatable, nonAggregatable, reportColumnMetaData, ReportColumns } from "../../constants/earningsReport";
import { RenderAdReportTable } from "../../components/admanger/RenderAdReportTable";


export default function UserEarningsReport():ReactElement {

  const adboxReports = useSelector(getAdboxReport)
  return (
    <>
      <UserEarningsReportForm/>
      { RenderAdReportTable(adboxReports) }
    </>
  )
}
